import Client from './client';

export default class PlatformFeeChanges extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  get(organization, options = {}) {
    return this.makeRequest(`${this.host}/internal/${organization}/platform_fee_changes`, options);
  }

  getByKey(organization, key, options = {}) {
    return this.makeRequest(`${this.host}/internal/${organization}/platform_fee_changes/${key}`, options);
  }

  putByKey(organization, key, options = {}) {
    return this.makeRequest(`${this.host}/internal/${organization}/platform_fee_changes/${key}`, {
      ...options,
       method: 'PUT',
    });
  }

  deleteByKey(organization, key, options = {}) {
    return this.makeRequest(`${this.host}/internal/${organization}/platform_fee_changes/${key}`, {
      ...options,
       method: 'DELETE',
    });
  }

}
